import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Tab, Tabs } from '@mui/material';
import React from 'react';
import { OwnerLookup } from 'src/ui/business-associates/OwnerLookup';
import { LicenseeHistoryLookup } from 'src/ui/components/tools/LicenseeHistoryLookup';
import { MineralRightsLocationHistory } from 'src/ui/components/tools/MineralRightsLocationHistory';
import { ToolsPanelTab, useUI } from 'src/ui/contexts/useUIState';

export function ToolsPanel() {
  const {
    isToolsPanelOpen,
    handleToggleToolsPanel,
    toolsPanelTab,
    handleToolsPanelTabChange,
  } = useUI();

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: ToolsPanelTab
  ) => {
    handleToolsPanelTabChange(newValue);
  };

  return (
    <Box
      sx={(theme) => ({
        position: 'fixed',
        display: isToolsPanelOpen ? 'block' : 'none',
        top: 57,
        right: 0,
        height: 'calc(100% - 57px)',
        width: 700,
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
        zIndex: 1300,
        py: 1,
        backgroundColor: theme.palette.background.paper,
        borderLeft: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Box
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.palette.divider}`,
          px: 2,
        })}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          Tools Panel
          <IconButton
            size="small"
            aria-label="close"
            onClick={handleToggleToolsPanel}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Tabs value={toolsPanelTab} onChange={handleChange}>
          <Tab label="BA Lookup" />
          <Tab label="Location Agreement History" />
          <Tab label="Licensee History" />
        </Tabs>
      </Box>
      <Box sx={{ overflowY: 'auto', height: 'calc(100% - 76px)', p: 2 }}>
        <Box
          sx={{
            display:
              toolsPanelTab === ToolsPanelTab.BALookup ? 'block' : 'none',
          }}
        >
          <OwnerLookup />
        </Box>
        <Box
          sx={{
            display:
              toolsPanelTab === ToolsPanelTab.LocationAgreementHistory
                ? 'block'
                : 'none',
          }}
        >
          <MineralRightsLocationHistory />
        </Box>
        <Box
          sx={{
            display:
              toolsPanelTab === ToolsPanelTab.LicenseeHistory
                ? 'block'
                : 'none',
          }}
        >
          <LicenseeHistoryLookup />
        </Box>
      </Box>
    </Box>
  );
}
